import { Address, User } from '@spartacus/core';
import { CustomProductAddress, ShipToParty } from './addresses.model';
import { InfluenzaContactInfo } from './flu.model';

export interface CustomUser extends User {
  userName?: string;
  sapCustomerId?: string;
  accountType?: ACCOUNT_TYPE;
  wholesalerId?: string;
  pharmacyId?: string;
}
export interface CustomB2BUnit {
  active?: boolean;
  authorizationGroup?: string;
  billingAddress?: CustomProductAddress;
  customerGroup?: string;
  delFlagForCustomer?: boolean;
  hasIban?: boolean;
  hospital?: boolean;
  name?: string;
  payerAddress?: ShipToParty;
  salesOrg?: string;
  shippingAddresses?: CustomProductAddress[];
  shippingCondition?: string;
  soldToAddress?: ShipToParty;
  uid?: string;
  yellowFeverFlag?: boolean;
  influenzaContactInfos?: InfluenzaContactInfo[];
  contactAddress?: Address;
}

export enum USER_TYPE {
  PHARMACY = 'pharmacy',
  NBP = 'nbp',
}

export enum ACCOUNT_TYPE {
  DIRECT = 'DIRECT',
  INDIRECT = 'INDIRECT',
}
